function Variants() {
  return (
    <>
    <main class="flex-shrink-0">
      <div class="container">
        <h2 class="mt-5">Variants</h2>
        <p class="lead">
          Variant query tool similar to Polymorph.
        </p>
      </div>
    </main>
    </>
  );
}

export default Variants;
